// extracted by mini-css-extract-plugin
module.exports = {"container":"TickerSlide_container__31dkS","figure":"TickerSlide_figure__10I8r","img":"TickerSlide_img__3jlV6"};